import { useAtomCallback, useAtomValue, useExodus, useSelectors } from '@exodus/headless-ui';
import React from 'react';
import { useSelector } from 'react-redux';
import useTrackAssetConfigureEvent from '../../hooks/use-track-configure-asset.js';
import { toAssetAtom, toAssetsAtom, toWalletAccountAtom, isLoadingAtom, } from '../../../atoms/index.js';
const ToAsset = ({ Component, className, style, onPress }) => {
    const exodus = useExodus();
    const selectors = useSelectors();
    const isLoading = useAtomValue(isLoadingAtom);
    const toAsset = useAtomValue(toAssetAtom);
    const toWalletAccount = useAtomValue(toWalletAccountAtom);
    const availableAssets = useSelector(selectors.availableAssets.all);
    const enabledAssets = useSelector(selectors.enabledAssets.data);
    const trackAssetConfigureSwap = useTrackAssetConfigureEvent();
    const handlePress = useAtomCallback(async (get, set) => {
        const source = await onPress?.({
            side: 'to',
            assets: await get(toAssetsAtom),
            walletAccount: get(toWalletAccountAtom).toString(),
        });
        if (!source)
            return;
        const { asset, walletAccount } = source;
        try {
            void trackAssetConfigureSwap();
            const shouldEnableAsset = asset && (!availableAssets[asset.name] || !enabledAssets[asset.name]);
            if (shouldEnableAsset) {
                await exodus.exchange.addAndEnableToken(asset.assetId, asset.baseAssetName);
            }
            if (asset)
                set(toAssetAtom, asset);
            if (walletAccount)
                set(toWalletAccountAtom, walletAccount);
        }
        catch {
            console.warn('failed to add token', asset);
        }
    }, [exodus, trackAssetConfigureSwap, onPress]);
    if (Component) {
        return (React.createElement(Component, { side: "to", asset: toAsset, walletAccount: toWalletAccount, loading: isLoading, className: className, style: style, onPress: handlePress }));
    }
    return null;
};
export default ToAsset;
